import { Component, Input } from "@angular/core";

@Component({
  selector: "app-tooltip-content",
  template: `
    <div class="ion-padding tooltip-content">
      <!-- Structured key-value tooltip -->
      <ng-container *ngIf="isObject(content); else plainText">
        <div class="tooltip-row" *ngFor="let key of objectKeys(content)">
          <span class="tooltip-key">{{ key }}</span>
          <span class="tooltip-value">{{ content[key] }}</span>
        </div>
      </ng-container>

      <!-- Plain text tooltip -->
      <ng-template #plainText>
        {{ content }}
      </ng-template>
    </div>
  `,
})
export class TooltipContentComponent {
  @Input() content!: string | Record<string, string>;
  @Input() onMouseEnter?: () => void;
  @Input() onMouseLeave?: () => void;

  objectKeys = Object.keys;

  isObject(value: any): value is Record<string, string> {
    return value !== null && typeof value === "object";
  }
}
